/** Glow a grid row orange for a moment so a Compare ↔ Workspace jump shows where it landed. */
export function flashRow(row: Element | null | undefined): void {
  if (!row) return;
  row.classList.remove('fv3-row-flash');
  // Reflow so a repeat jump to the same row restarts the animation.
  void (row as HTMLElement).offsetWidth;
  row.classList.add('fv3-row-flash');
  window.setTimeout(() => row.classList.remove('fv3-row-flash'), 2800);
}
